export function SkeBeta() {
	return (
		<span className="mx-5 badge rounded-pill bg-info">Beta</span>
	);
}
